import {
  useLazyGetClientCellsQuery,
  useLazyGetExternalClientCellsQuery,
  usePerformPbxCallMutation,
} from "features/shared/api"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import theme from "utils/themeVars"
import { Button, Dropdown, notification } from "../../common"

const IntelliconButton = props => {
  const { t } = useTranslation()
  const { client, disabled, leadId, from, ...buttonProps } = props
  const userInfo = useSelector(state => state.app.user?.info)
  const [getClientCellInfo, { data: clientCells, isFetching: fetchClientCell }] = useLazyGetClientCellsQuery()
  const [getExternalClientInfo, { data: externalCells, isFetching: fetchExternalClientCell }] =
    useLazyGetExternalClientCellsQuery()

  const [performPBXCall] = usePerformPbxCallMutation()

  const onClick = e => {
    e.domEvent.stopPropagation()
    performPBXCall({ number: items[e.key].label })
      .unwrap()
      .catch(e => {
        notification.error({ message: e?.message })
      })
  }

  const onCopy = e => {
    e.preventDefault()
  }
  const onContextMenu = e => {
    e.preventDefault()
  }

  const items = useMemo(
    () =>
      (from === "external" ? externalCells : clientCells)?.map((e, index) => {
        return { label: e, key: index }
      }),
    [clientCells, externalCells]
  )

  return (
    <Dropdown
      menu={{ items, onClick, onCopy, onContextMenu }}
      dropdownRender={menu => (items?.length ? <div className="dropdown-content">{menu}</div> : <></>)}
      placement="bottomLeft"
      suffixIcon=""
      disabled={disabled}
    >
      <Button
        icon={"SvgIntellicon"}
        iconProps={{ size: 20 }}
        loading={fetchClientCell || fetchExternalClientCell}
        onClick={e => {
          e.stopPropagation()
          from === "external"
            ? getExternalClientInfo({ clientId: client?.id, actionType: "tooltip", type: "intellicon" })
            : getClientCellInfo({ clientId: client?.id, actionType: "tooltip" })
        }}
        content={t("Intellicon")}
        // color="#FCA41C"
        color={theme["warning-color"]}
        shape="circle"
        type="light"
        disabled={!userInfo?.AgencyConfiguration?.Platform?.platformKey === "zameen" || disabled}
        {...buttonProps}
      />
    </Dropdown>
  )
}

export default IntelliconButton
